export default {
    awaiting: 1,
    running: 2,
    finished: 3,
    error: 4,
};
